/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarcatoreDto } from '../../models/marcatore-dto';

export interface ApiMarcatoreMarcatoreByIdGet$Params {
    /**
     * Id del marcatore
     */
    marcatoreId: number;
}

export function apiMarcatoreMarcatoreByIdGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiMarcatoreMarcatoreByIdGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<MarcatoreDto>> {
    const rb = new RequestBuilder(rootUrl, apiMarcatoreMarcatoreByIdGet.PATH, 'get');
    if (params) {
        rb.query('marcatoreId', params.marcatoreId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<MarcatoreDto>;
        }),
    );
}

apiMarcatoreMarcatoreByIdGet.PATH = '/api/marcatore/marcatore-by-id';
